<div class="blog-setting-container">
  <div class="blog-setting-top">
    <div class="blog-setting-title">ویرایش پروفایل</div>
    <div class="back-holder" (click)="closeProfile()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div *ngIf="dataIsReady" class="blog-setting-mid">
    <div class="blog-setting-img" (click)="openImageBottomsheet()">
      <img
        *ngIf="blogUser.avatarPath !== ''"
        src="{{ blogUser.avatarPath }}"
        onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
      />
      <img *ngIf="blogUser.avatarPath === ''" src="assets/blog/avatar.svg" />
    </div>
    <div class="blog-setting-change-img" (click)="openImageBottomsheet()">
      تغییر وضعیت عکس
    </div>
    <div class="blog-setting-info-table">
      <div
        *ngFor="let profileTitle of profileTitles; let i = index"
        class="blog-setting-info-cell"
        (click)="openEdit(i)"
      >
        <div class="blog-setting-info-cell-title">{{ profileTitle }}</div>
        <div class="blog-setting-info-cell-value">{{ profileValues[i] }}</div>
        <img
          class="blog-setting-info-cell-more-icon"
          src="assets/general/left-gray.svg"
        />
      </div>
    </div>
  </div>

  <div class="profile-page" id="profilePage{{ id }}" *ngIf="showProfile">
    <app-blog-profile
      [id]="profileId"
      [username]="selectedUsername"
      style="width: 100%; height: 100%"
    ></app-blog-profile>
    <div class="blog-back-holder" (click)="closeProfile()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>

  <div class="crop-holder" *ngIf="showCropImage" id="croppedImageView">
    <div class="crop-nav-bar">
      <div class="crop-back-holder" (click)="closeCropImage()">
        <img src="assets/general/back-blue.svg" />
      </div>
    </div>
    <div
      style="
        width: 100%;
        position: relative;
        height: calc(100% - 56px);
        top: 0;
        left: 0;
        overflow-y: auto;
      "
    >
      <div
        *ngIf="!croppedImage"
        [ngClass]="
          isActive
            ? 'submit-box-select submit-active-crop'
            : 'submit-box-select submit-disable-crop'
        "
        id="submit-button"
        (click)="runLoading()"
      >
        <div class="submit-title">انتخاب عکس</div>
      </div>
      <input
        type="file"
        id="file"
        style="display: none"
        (change)="fileChangeEvent($event)"
      />
      <div *ngIf="imageChangedEvent" class="crop-img-holder">
        <image-cropper
          [imageChangedEvent]="imageChangedEvent"
          [maintainAspectRatio]="true"
          [aspectRatio]="1 / 1"
          [resizeToWidth]="512"
          format="jpeg"
          (imageCropped)="imageCropped($event)"
          (imageLoaded)="imageLoaded()"
          (cropperReady)="cropperReady()"
          (loadImageFailed)="loadImageFailed()"
          class="cropper"
        ></image-cropper>
      </div>
      <div *ngIf="croppedImage" class="crop-submit-holder">
        <div class="rotate-image" (click)="rotateLeft()">
          <img src="assets/blog/rotate.svg" />
        </div>
      </div>
      <div *ngIf="croppedImage" class="crop-submit-holder">
        <div
          [ngClass]="
            isActive
              ? 'submit-box-crop submit-active-crop'
              : 'submit-box-crop submit-disable-crop'
          "
          id="submit-button"
          (click)="saveImageProfile()"
        >
          <div class="submit-title">ثبت</div>
        </div>
      </div>
    </div>
  </div>
  <app-report-bottomsheet
    *ngIf="showBottomsheet"
    [data]="bottomsheetData"
  ></app-report-bottomsheet>
  <app-edit-bottomsheet
    *ngIf="showEdit"
    [type]="selectedType"
    [user]="user"
    [blogUser]="blogUser"
  ></app-edit-bottomsheet>
</div>
